import { Box, Button, IconButton, Text } from "@chakra-ui/react";
import { MdAdd } from "react-icons/md";
import * as React from "react";

function AppendToListButton({ onClick, buttonText }) {
  return (
    <Box>
      <Button
        padding="0"
        variant="ghost"
        display="flex"
        alignItems="center"
        onClick={onClick}
        _hover={{
          background: "inherit"
        }}
        _focus={{
          outline: "none",
          textDecoration: "underline"
        }}
      >
        <IconButton
          as="div"
          variant="outline"
          borderRadius="full"
          size="sm"
          tabIndex={-1}
          pointerEvents="none"
          flexShrink="0"
          icon={<MdAdd size="20" />}
        />
        <Text marginInlineStart="2">{buttonText}</Text>
      </Button>
    </Box>
  );
}

export default AppendToListButton;